export function DollarsignIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 2a1 1 0 011 1v1.073c1.823.295 3.374 1.456 3.945 3.099a1 1 0 01-1.89.656C14.79 7.06 14.035 6.373 13 6.112v4.993c2.198.429 4 2.134 4 4.395 0 2.261-1.802 3.966-4 4.395V21a1 1 0 11-2 0v-1.073a5.34 5.34 0 01-2.558-1.138 4.455 4.455 0 01-1.387-1.96 1 1 0 011.89-.657c.137.395.399.768.771 1.076.348.288.786.513 1.284.64v-4.993c-2.198-.429-4-2.134-4-4.395 0-2.261 1.802-3.966 4-4.395V3a1 1 0 011-1zm1 15.844c1.234-.374 2-1.364 2-2.344 0-.98-.766-1.97-2-2.344v4.688zM9 8.5c0 .98.766 1.97 2 2.344V6.156C9.766 6.53 9 7.521 9 8.5z"
      ></path>
    </svg>
  );
}
